import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const featuredCategories = categories.filter((c) => c.featured);
  const otherCategories = categories.filter((c) => !c.featured);

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2.5 mb-4 group">
                <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-semibold text-background-50 whitespace-nowrap">
                  妖精视频
                </span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-4">
                妖精视频水果植物系列，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，高清免费在线观看，电视剧全集不缓冲。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-accent-500 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-accent-500 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:bg-accent-500 transition-all cursor-pointer" aria-label="哔哩哔哩">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {featuredCategories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
              <ul className="space-y-2.5">
                {otherCategories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    全部视频
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2024 妖精视频 版权所有 | 妖精视频水果植物系列
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors cursor-pointer">
                网站地图
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}